import { AcademicFeePriceDto } from './academicfeepricedto';
import { PaginationFeaturesDto } from './paginationfeaturesdto';

export class AcademicFeePriceRequest {

    academicPriceFeeDto: AcademicFeePriceDto = new AcademicFeePriceDto();

    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}